<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields"
      pageName="topTrendingVideos" :permission="permission" :buttons="buttons" :searchs="searchs" @returnId="returnId"
      @vieoUpdate="vieoUpdate" ref="table"></common-table>
    <div class="dialog">
      <el-dialog title="批量剪映" :visible.sync="batchVisible" custom-class="common-dialog" :close-on-click-modal="false"
        @close="resetForm('batchForm')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="batchForm" ref="batchForm">
            <el-form-item label="模板:" prop="productTemplateNumber"
              :rules="[{ required: true, message: '模板不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="batchForm.productTemplateNumber" clearable placeholder="请选择模板"
                size="medium" class="mr10 mb-10">
                <el-option v-for="(option, index) in productTemplates" :key="index" :label="option.name"
                  :value="option.id" />
              </el-select>
            </el-form-item>
          </el-form>

        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatch('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    
    <div class="dialog">
      <el-dialog title="批量修改发布状态" :visible.sync="releaseStatusVisible" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetForm('releaseStatusForm')" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="100px" :model="releaseStatusForm" ref="releaseStatusForm">
            <el-form-item label="发布状态:" prop="releaseStatus"
              :rules="[{ required: true, message: '请选择状态', trigger: 'change' }]">
              <el-select v-model="releaseStatusForm.releaseStatus" placeholder="请选择发布状态" size="medium">
                <el-option label="待剪辑" :value="1"></el-option>
                <el-option label="剪辑成功" :value="2"></el-option>
                <el-option label="发布成功" :value="3"></el-option>
                <el-option label="剪辑失败" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="releaseStatusVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatchReleaseStatus('releaseStatusForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="dialog">
      <el-dialog title="播放视频" :visible.sync="showVideoVisible" custom-class="common-dialog"
        :close-on-click-modal="false" width="30%">
        <video class="product_video" :loop="true" controls :autoplay="true" :src="videoSrc"></video>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button size="small" @click="showVideoVisible = false">取 消</el-button> -->
          <el-button type="primary" size="small" @click="showVideoVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 新增：更新视频对话框 -->
    <el-dialog title="更新视频" :visible.sync="updateVideoVisible" @close="resetForm('updateVideoForm')">
      <el-form label-position="right" label-width="120px" :model="updateVideoForm" ref="updateVideoForm">
        <el-form-item label="视频存放地址:" prop="newVideoPath"
          :rules="[{ required: true, message: '视频存放地址不能为空', trigger: 'blur' }]">
          <el-input v-model="updateVideoForm.newVideoPath" placeholder="请输入新视频地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateVideoVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpdateVideo('updateVideoForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "@/utils/message";
import request from "@/utils/axios";

const clipModeOptions = [{
  id: 0,
  name: '云端剪辑'
}, {
  id: 1,
  name: '本地剪辑'
}]

const clipModeSearchOptions = [{
  key: 0,
  value: '云端剪辑',
}, {
  key: 1,
  value: '本地剪辑',
}]

const clipModeTagOptions = [{
  key: 0,
  value: '云端剪辑',
  type: 'info'
}, {
  key: 1,
  value: '本地剪辑',
  type: 'success'
}]

export default {
  name: 'TopTrendingVideos',
  components: { CommonTable },
  data() {
    return {
      updateVideoForm: {
        id: '',
        newVideoPath: ''
      },
      updateVideoVisible: false,
      videoSrc: '',
      showVideoVisible: false,
      selectIds: [],
      batchVisible: false,
      productTemplates: [],//用户id集合
      batchForm: {
        ids: '',
        productTemplateNumber: ''
      },
      releaseStatusVisible: false,
      releaseStatusForm: {
        ids: '',
        releaseStatus: null
      },
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'productCategoryId',
        placeholder: '商品类别',
        type: 'select',
        selectUrl: '/productCategory/getAll',
        selectData: [],
      }, {
        name: 'platformType',
        placeholder: '类型',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '抖音',
        }, {
          key: 2,
          value: '快手',
        }]
      }, {
        name: 'clipMode',
        placeholder: '剪辑方式',
        type: 'select',
        selectValue: clipModeSearchOptions
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '未剪辑',
        }, {
          key: 2,
          value: '剪辑中',
        }, {
          key: 3,
          value: '剪辑完成',
        }, {
          key: 4,
          value: '剪辑失败',
        }]
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      },
      {
        name: 'downloadStatus',
        placeholder: '下载状态',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '未下载',
        }, {
          key: 1,
          value: '下载中',
        }, {
          key: 2,
          value: '下载成功',
        }, {
          key: 3,
          value: '下载失败',
        }]
      }
        // ,
        //   {
        //   name: 'digitalHumanStatus',
        //   placeholder: '数字人剪辑状态',
        //   type: 'select',
        //   selectValue: [{
        //     key: 1,
        //     value: '未剪辑',
        //   }, {
        //     key: 2,
        //     value: '剪辑中',
        //   }, {
        //     key: 3,
        //     value: '剪辑完成',
        //   }]
        // }
        /*, {
          name: 'isJianYing',
          placeholder: '是否剪映',
          type: 'select',
          selectValue: [{
            key: 1,
            value: '是',
          }, {
            key: 0,
            value: '否',
          }]
        }*/
        // ,
        //   {
        //   name: 'footageStatus',
        //   placeholder: '素材状态',
        //   type: 'select',
        //   selectValue: [{
        //     key: 1,
        //     value: '视频',
        //   }, {
        //     key: 0,
        //     value: '仅图片',
        //   }]
        // },
        //   {
        //   name: 'isDigitalHuman',
        //   placeholder: '是否生成数字人',
        //   type: 'select',
        //   selectValue: [{
        //     key: true,
        //     value: '是',
        //   }, {
        //     key: false,
        //     value: '否',
        //   }]
        // },
        ,
      {
        name: 'productTitle',
        placeholder: '商品标题',
        type: 'input'
      },
      {
        name: 'callbackLog',
        placeholder: '下载日志',
        type: 'select',
        selectValue: [{
          key: "isNOtNull",
          value: '不为空',
        }]
      }, {
        name: 'devicesId',
        placeholder: '设备信息',
        type: 'select',
        selectUrl: '/devices/getAll',
        selectData: [],
      }, {
        name: 'videoEditFinishTimeStart',
        placeholder: '剪辑视频回调开始时间',
        type: 'dateTime'
      }, {
        name: 'videoEditFinishTimeEnd',
        placeholder: '剪辑视频回调结束时间',
        type: 'dateTime'
      },
      {
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      },
      ],
      permission: {
        add: 'topTrendingVideos:add',
        update: 'topTrendingVideos:update',
        delete: 'topTrendingVideos:delete',
        deleteBatch: 'topTrendingVideos:deleteBatch'
      },
      url: {
        get: '/topTrendingVideos/listByCondition',
        add: '/topTrendingVideos/add',
        update: '/topTrendingVideos/update',
        delete: '/topTrendingVideos/delete',
        delete_batch: '/topTrendingVideos/deleteBatch',
        status: '/topTrendingVideos/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'contentId',
        label: '视频ID',
        detail: true,
        show: false,
      },
      {
        field: 'productLink',  // 字段名
        label: '商品链接',  // 字段显示名称
        sort: false,  // 是否排序
        detail: true,
        show: false,
      }, {
        field: 'douYinVideoAddress',  // 字段名
        label: '抖音视频地址',  // 字段显示名称
        sort: false,  // 是否排序
        detail: true,
        show: false,
      }
        , {
        field: 'productTitle',  // 字段名
        label: '商品标题',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'productTag',  // 字段名
        label: '商品标签',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'productCover',  // 字段名
        label: '商品封面',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
        img: true,
      }, {
        field: 'path',  // 字段名
        label: '视频存放地址',  // 字段显示名称
        sort: false,  // 是否排序
        detail: true,
        show: false,
      }, {
        field: 'digitalHumanUrl',  // 字段名
        label: '数字人视频存放地址',  // 字段显示名称
        sort: false,  // 是否排序
        detail: true,
        show: false,
      }, {
        field: 'keyWord',  // 字段名
        label: '关键词',  // 字段显示名称
        sort: false,  // 是否排序
        detail: false,
        show: true,
      }, {
        field: 'duration',  // 字段名
        label: '时长',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'platformType',  // 字段名
        label: '平台类型',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '抖音'
        }, {
          id: 2,
          name: '快手'
        }],
      }, {
        field: 'productCategoryId',
        label: '商品类别',
        selectUrl: '/productCategory/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      }/*, {
          field: 'isJianYing',
          label: '是否剪映',
          show: true,
          status: true,
        }*/, {
        field: 'status',  // 字段名
        label: '状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '未剪辑',
            type: 'warning'
          }, {
            key: 2,
            value: '剪辑中',
            type: 'warning'
          }, {
            key: 3,
            value: '剪辑完成',
            type: 'success'
          }, {
            key: 4,
            value: '剪辑失败',
            type: 'danger'
          }]
        },
      }, {
        field: 'releaseStatus',
        label: '发布状态',
        sort: false,
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '待剪辑',
            type: 'info'
          }, {
            key: 2,
            value: '剪辑成功',
            type: 'success'
          }, {
            key: 3,
            value: '发布成功',
            type: 'primary'
          }, {
            key: 4,
            value: '剪辑失败',
            type: 'danger'
          }]
        },
      },
      // {
      //   field: 'digitalHumanStatus',  // 字段名
      //   label: '数字人状态',  // 字段显示名称
      //   sort: false,  // 是否排序
      //   show: {
      //     type: 'tag',
      //     tags: [{
      //       key: 1,
      //       value: '未剪辑',
      //       type: 'warning'
      //     }, {
      //       key: 2,
      //       value: '剪辑中',
      //       type: 'warning'
      //     }, {
      //       key: 3,
      //       value: '剪辑完成',
      //       type: 'success'
      //     },{
      //       key: 4,
      //       value: '剪辑失败',
      //       type: 'danger'
      //     }]
      //   },
      // },
      // {
      //   field: 'precedence',
      //   label: '优先剪辑',
      //   show: true,
      //   status: true,
      // },
      // {
      //   field: 'imageStatus',  // 字段名
      //   label: '商品图片采集状态',  // 字段显示名称
      //   sort: false,  // 是否排序
      //   show: {
      //     type: 'tag',
      //     tags: [{
      //       key: 0,
      //       value: '未采集',
      //       type: 'warning'
      //     }, {
      //       key: 1,
      //       value: '采集中',
      //       type: 'warning'
      //     }, {
      //       key: 2,
      //       value: '采集完成',
      //       type: 'success'
      //     }]
      //   },
      // },
      // {
      //   field: 'footageStatus',  // 字段名
      //   label: '素材状态',  // 字段显示名称
      //   sort: false,  // 是否排序
      //   show: {
      //     type: 'tag',
      //     tags: [{
      //       key: 0,
      //       value: '仅图片',
      //       type: 'warning'
      //     }, {
      //       key: 1,
      //       value: '视频',
      //       type: 'success'
      //     },]
      //   },
      // },
      {
        field: 'devices',
        label: '设备名称',
        show: true,
      }, {
        field: 'videoType',
        label: '视频类型',
        show: {
          type: 'tag',
          tags: [
            {
              key: 0,
              value: '二创',
              type: 'info'
            },
            {
              key: 1,
              value: 'AI视频',
              type: 'success'
            }
          ]
        },
      }, {
        field: 'clipMode',
        label: '剪辑方式',
        width: '110',
        show: {
          type: 'tag',
          tags: clipModeTagOptions
        },
      }, {
        field: 'productTemplateNumber',
        label: '模板编号',
        width: '160',
        show: true,
        detail: true,
      }, {
        field: 'commissionRate',  // 字段名
        label: '佣金比例',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'sellingPrice',
        label: '售价',
        show: true,
      }, {
        field: 'commission',
        label: '佣金',
        show: true,
      }
        ,
      // {
      //   field: 'productTemplateTitle',
      //   label: '模板标题',
      //   show: true,
      // },
      {
        field: 'points',
        label: '所需积分',
        show: true,
      },
      // {
      //   field: 'isDigitalHuman',  // 字段名
      //   label: '是否生成数字人',  // 字段显示名称
      //   sort: false,  // 是否排序
      //   show: {
      //     type: 'tag',
      //     tags: [{
      //       key: false,
      //       value: '否',
      //       type: 'warning'
      //     }, {
      //       key: true,
      //       value: '是',
      //       type: 'success'
      //     },]
      //   },
      // },
      // {
      //   field: 'digitalHumanUrl',
      //   label: '数字人存储链接',
      //   show: true,
      // },
      {
        field: 'voiceover',
        label: '口播',
        show: false,
        detail: true,
      }, {
        field: 'nasPath',
        label: 'nas数据存放地址',
        show: false,
        detail: true,
      }, {
        field: 'nasDigitalHumanPath',
        label: 'nas数字人存放地址',
        show: false,
        detail: true,
      }, {
        field: 'productId',
        label: '商品Id',
        show: false,
        detail: true,
      }, {
        field: 'callbackLog',
        label: '回调日志',
        show: true,
        detail: true,
      }, {
        field: 'fileSizeBytes',
        label: '文件大小(字节)',
        show: false,
        detail: true,
      }, {
        field: 'vipId',
        label: '会员用户',
        show: false,
        detail: true,
      }, {
        field: 'downloadStatus',  // 字段名
        label: '下载状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'tag',
          tags: [
            {
              key: 0,
              value: '未下载',
              type: 'info'
            },
            {
              key: 1,
              value: '下载中',
              type: 'default'
            },
            {
              key: 2,
              value: '下载成功',
              type: 'success'
            },
            {
              key: 3,
              value: '下载失败',
              type: 'danger'
            }
          ]
        },
      }, {
        field: 'videoCallbackLog',
        label: '视频剪辑回调日志',
        show: true,
        detail: false,
      },
      {
        field: 'updateTime',
        label: '修改时间',
        show: true,
        width: '',
      },
      {
        field: 'createTime',
        label: '创建时间',
        show: true,
        width: '',
      }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            isEdit: true
          }, {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'productLink',  // 字段名
            label: '商品链接',  // 字段显示名称
            type: 'input',
            placeholder: '请输入商品链接',
            rules: [
              { required: false, message: '商品链接不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'douYinVideoAddress',  // 字段名
            label: '抖音视频地址',  // 字段显示名称
            type: 'input',
            placeholder: '请输入抖音视频地址',
            rules: [
              { required: false, message: '抖音视频地址不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'videoType',
            label: '视频类型',
            type: 'select',
            placeholder: '请选择视频类型',
            rules: [{ required: true, message: '请选择视频类型', trigger: 'blur' }],
            selectData: [{
              id: 0,
              name: '二创'
            }, {
              id: 1,
              name: 'AI视频'
            }],
            add: true,
            update: true,
          }, {
            field: 'clipMode',
            label: '剪辑方式',
            type: 'select',
            placeholder: '请选择剪辑方式',
            rules: [{ required: true, message: '请选择剪辑方式', trigger: 'change' }],
            selectData: clipModeOptions,
            add: true,
            update: true,
          }, {
            field: 'productTemplateNumber',
            label: '模板编号',
            type: 'input',
            placeholder: '本地剪辑时填写本地模板编码',
            add: true,
            update: true,
          }
          // , {
          //   field: 'productCover',  // 字段名
          //   label: '商品封面',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入商品封面',
          //   rules: [
          //     { required: false, message: '商品封面不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'productTitle',  // 字段名
          //   label: '商品标题',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入商品标题',
          //   rules: [
          //     { required: false, message: '商品标题不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'productTag',  // 字段名
          //   label: '商品标签',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入商品标签',
          //   rules: [
          //     { required: false, message: '商品标签不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'path',  // 字段名
          //   label: '视频存放地址',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入视频存放地址',
          //   rules: [
          //     { required: false, message: '视频存放地址不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'duration',  // 字段名
          //   label: '时长',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入时长',
          //   rules: [
          //     { required: false, message: '时长不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'commissionRate',  // 字段名
          //   label: '佣金比例',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入佣金比例',
          //   rules: [
          //     { required: false, message: '佣金比例不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'keyWord',  // 字段名
          //   label: '关键词',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入关键词',
          //   rules: [
          //     { required: false, message: '关键词不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'platformType',  // 字段名
          //   label: '平台类型',  // 字段显示名称
          //   type: 'select',
          //   placeholder: '请选择平台类型',
          //   rules: [
          //     { required: false, message: '平台类型不能为空', trigger: 'blur' }
          //   ],
          //   selectData: [{
          //     id: 1,
          //     name: '抖音'
          //   }, {
          //     id: 2,
          //     name: '快手'
          //   }],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'status',
          //   label: '状态：',
          //   type: 'select',
          //   placeholder: '请选择状态',
          //   rules: [{ required: true, message: '请选择状态', trigger: 'blur' }],
          //   selectData: [{
          //     id: 1,
          //     name: '未剪辑'
          //   }, {
          //     id: 2,
          //     name: '剪辑中'
          //   }, {
          //     id: 3,
          //     name: '剪辑完成'
          //   }],
          //   add: true,
          //   update: true,
          //   filterable: true,
          // }, {
          //   field: 'isDigitalHuman',
          //   label: '是否生成数字人：',
          //   type: 'select',
          //   placeholder: '请选择数字人状态',
          //   rules: [{ required: true, message: '请选择数字人状态', trigger: 'blur' }],
          //   selectData: [{
          //     id: false,
          //     name: '否'
          //   }, {
          //     id: true,
          //     name: '是'
          //   }],
          //   add: true,
          //   update: true,
          //   filterable: true,
          // }, {
          //   field: 'digitalHumanStatus',
          //   label: '数字人状态：',
          //   type: 'select',
          //   placeholder: '请选择数字人状态',
          //   rules: [{ required: true, message: '请选择数字人状态', trigger: 'blur' }],
          //   selectData: [{
          //     id: 1,
          //     name: '未剪辑'
          //   }, {
          //     id: 2,
          //     name: '剪辑中'
          //   }, {
          //     id: 3,
          //     name: '剪辑完成'
          //   }, {
          //     id: 4,
          //     name: '失败'
          //   }],
          //   add: true,
          //   update: true,
          //   filterable: true,
          // }, {
          //   field: 'productCategoryId',
          //   label: '商品类别：',
          //   type: 'select',
          //   placeholder: '请选择商品类别',
          //   rules: [{ required: false, message: '请选择商品类别', trigger: 'blur' }],
          //   selectUrl: '/productCategory/getAll',
          //   selectData: [],
          //   add: true,
          //   update: true,
          //   filterable: true,
          // }, {
          //   field: 'footageStatus',
          //   label: '素材状态：',
          //   type: 'select',
          //   placeholder: '请选择商品图片采集状态',
          //   rules: [{ required: false, message: '请选择状态', trigger: 'blur' }],
          //   selectData: [{
          //     id: 0,
          //     name: '图片'
          //   }, {
          //     id: 1,
          //     name: '视频'
          //   }],
          //   add: true,
          //   update: true,
          //   filterable: true,
          // }, {
          //   field: 'points',  // 字段名
          //   label: '积分',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入积分',
          //   rules: [
          //     { required: false, message: '积分不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'voiceover',  // 字段名
          //   label: '口播',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入口播文案',
          //   rules: [
          //     { required: false, message: '请输入口播文案', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }, {
          //   field: 'digitalHumanUrl',  // 字段名
          //   label: '数字人转存链接',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '数字人转存链接',
          //   rules: [
          //     { required: false, message: '数字人转存链接', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // },
        ]
      },
      operate: [{
        icon: 'el-icon-video-camera',
        type: 'text',
        text: '更新视频',
        handle: (row) => {
          this.handleUpdateVideo(row)
        }
      }, {
        icon: 'el-icon-upload3',
        type: 'text',
        text: '上传',
        uploadVideo: true,
        url: this.reUrl + '/topTrendingVideos/upload/ossVideo',
        // 用于存储handle的row
        value: {},
        handle: (row) => {
          console.log('112233')
          this.value = row
        },
        success: (res) => {
          if (res.code === 0) {
            const value = JSON.parse(JSON.stringify(this.value))
            value.path = res.data
            value.status = 3
            this.$axios.post({
              url: '/topTrendingVideos/update',
              data: value,
              success: (data) => {
                if (data.code === 0) {
                  this.$message.success('文件上传成功')
                  this.$set(this.value, 'path', value.path)
                  this.$refs.table.getData()
                } else {
                  this.$message.error(data.msg ? data.msg : '文件上传失败')
                }
              },
            })
          } else if (res.code === 102) {
            window.localStorage.removeItem('username')
            window.localStorage.removeItem('sessionId')
            window.parent.location.href = this.feUrl + '/login.html'
          }
        },
      }, {
        icon: 'el-icon-video-camera',
        type: 'text',
        text: '播放存储mp4_url',
        playVideo: true,
        handle: (row) => {
          console.log(row.path, '123123')
          if (row.path) {
            this.showVideoVisible = true
            this.videoSrc = row.path
          }
        },
      }, {
        icon: 'el-icon-edit',
        type: 'text',
        text: '剪辑',
        exist: (row) => {
          return row.status === 1 && this.$refs.table.havePermission('topTrendingVideos:update')
        },
        handle: (row) => {
          if (row.status != 1) {
            message.warning("已剪辑，不可重复操作");
            return;
          }
          request.post({
            url: '/topTrendingVideos/update',
            data: { id: row.id, status: 2 },
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }, {
        icon: 'el-icon-edit',
        type: 'text',
        text: '采集商品图片',
        exist: (row) => {
          return row.imageStatus === 0 && this.$refs.table.havePermission('cuttingTask:update')
        },
        handle: (row) => {
          if (row.imageStatus != 0) {
            message.warning("采集中，不可重复操作");
            return;
          }
          request.post({
            url: '/topTrendingVideos/update',
            data: { id: row.id, imageStatus: 1 },
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      },],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量剪辑',
        permission: 'topTrendingVideos:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要剪辑的数据')
            return
          }
          request.post({
            url: '/topTrendingVideos/batch/1',
            data: { ids: this.selectIds.join(",") },
            success: (data) => {
              if (data.code === 0) {
                message.success("批量剪辑成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量剪辑数字人',
        permission: 'topTrendingVideos:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要剪辑的数据')
            return
          }
          request.post({
            url: '/topTrendingVideos/batch/3',
            data: { ids: this.selectIds.join(",") },
            success: (data) => {
              if (data.code === 0) {
                message.success("批量剪辑数字人成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-info',
        type: 'info',
        text: '批量剪映',
        permission: 'topTrendingVideos:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要剪映的数据')
            return
          }

          request.post({
            url: '/productTemplate/getAll',
            success: (data) => {
              if (data.code == 0) {
                console.log(data, "123123")
                this.productTemplates = data.data;
                this.batchForm.ids = this.selectIds.join(",")
                this.batchVisible = true
              }
            }
          });
        }
      }, {
        icon: 'el-icon-info',
        type: 'info',
        text: '批量修改生成数字人',
        permission: 'topTrendingVideos:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          request.post({
            url: '/topTrendingVideos/batch/4',
            data: { ids: this.selectIds.join(",") },
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改生成数字人成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量修改视频状态',
        permission: 'topTrendingVideos:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改视频状态的数据')
            return
          }
          request.post({
            url: '/topTrendingVideos/batch/5',
            data: { ids: this.selectIds.join(",") },
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改视频状态成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量重置视频下载状态',
        permission: 'topTrendingVideos:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改视频状态的数据')
            return
          }
          request.post({
            url: '/topTrendingVideos/batch/6',
            data: { ids: this.selectIds.join(",") },
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改视频状态成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-edit',
        type: 'primary',
        text: '批量修改发布状态',
        permission: 'topTrendingVideos:update',
        click: () => {
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          this.releaseStatusForm.ids = this.selectIds.join(",")
          this.releaseStatusVisible = true
        }
      },],
    }
  },
  methods: {
    handleUpdateVideo(row) {
      this.updateVideoForm = {
        id: row.id,
        path: row.newVideoPath || ''
      }
      this.updateVideoVisible = true
    },
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    vieoUpdate(data) {
      this.operate[0].value = data
      this.$refs.table.getData()
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }, submitUpdateVideo(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          request.post({
            url: '/topTrendingVideos/upload/newVideoPath',
            data: this.updateVideoForm,
            success: (data) => {
              if (data.code === 0) {
                message.success("视频更新成功");
                this.updateVideoVisible = false;
                this.$refs.table.getData();  // 刷新表格数据
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      })
    },
    submitBatch(formName) {
      // console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/topTrendingVideos/batch/2',
            data: this.batchForm,
            success: (data) => {
              if (data.code === 0) {
                message.success("批量剪映成功");
                this.batchVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      })
    },
    submitBatchReleaseStatus(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/topTrendingVideos/batch/7',
            data: this.releaseStatusForm,
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改成功");
                this.releaseStatusVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      })
    },
  },
}
</script>

<style scoped></style>
